import React from 'react';
import { getTranslateByKey } from '@/main/services/utils';
import * as S from './styles';

interface ITypographyVehicleProps {
  manufacturer: string;
  model?: string;
  subModel?: string;
  year?: string;
  licensePlate?: string;
}
function TypographyVehicle({
  manufacturer,
  model,
  subModel,
  year,
  licensePlate
}: ITypographyVehicleProps) {
  const concatVehicle = [manufacturer, model, subModel, year, licensePlate].filter(Boolean).join(' ');

  return (
    <S.Paragraph>
      <S.LabelVehicle>{getTranslateByKey('information.vehicle')}: </S.LabelVehicle>
      {concatVehicle}
    </S.Paragraph>
  );
}

export default TypographyVehicle;